import React, { useEffect, useMemo, useRef, useState } from "react";
import { StyledDataGrid } from "../../../components/StyledComponents";
import CustomPagination from "../CustomPagination";
import NoRowOverlay from "../../../assets/images/icons/NoRowOverlay";
import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../../context/AuthContext";
import EditShiftRequestDialog from "./EditShiftRequestDialog";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import EditNew20pxSvg from "../../../assets/images/icons/EditNew20pxSvg";
import DeleteIcon16pxSvg from "../../../assets/images/icons/DeleteIcon16pxSvg";
import DetailShiftRequestDialog from "./DetailShiftRequestDialog";
import DetailShiftRequestDialogAR from "./DetailShiftRequestDialogAR";
import dayjs from 'dayjs';
import { deleteRequest, getRequestList, getRequestSwapList, requestById, requestSwapById, swapCalendar } from "../../../axios/Eventlog/EventLogApi";
import { toast } from "react-toastify";
import { format, parseISO } from "date-fns";
import { useLoading } from "../../../context/LoadingContext";
import {
    getHistoryRequest,
} from "../../../axios/Eventlog/EventLogApi";
import { DateTime } from "luxon";
import DetailShiftRequestDialogPartner from "./DetailShiftRequestDialogPartner";
import { useSearchParams } from "react-router-dom";
import { isAxiosError } from "axios";
import RemoveRequestDialog from "../EventLog/RemoveRequestDialog";
import { getListUserGroup } from "../../../axios/Group/GroupUrlApi";

const ShiftRequestGridTable = ({
    selectedUser,
    selectedGroup,
    selectedShift,
    selectedDate,
    selectedStatus,
    allUser,
    shiftsData,
    refreshData,
    handleRefreshData,
    usersData,
    GroupData
}) => {

    const { t } = useTranslation();
    const { profile, isAdmin, isEmployee, genaralSettingTimeZone, genaralSettingDateFormat } = useAuth();
    const [searchParams, setSearchParams] = useSearchParams();
    const requestShiftId = searchParams.get("requestShiftId");
    const requestIdParam = searchParams.get("requestId");
    const openedFromUrlRef = useRef(null);

    /* ================= Edit State ================= */
    const [openEditShiftRequest, setOpenEditShiftRequest] = useState(false);
    const [selectedRequest, setSelectedRequest] = useState(null);
    const [openDetailShiftRequest, setOpenDetailShiftRequest] = useState(false);
    const [selectedDetailRequest, setSelectedDetailRequest] = useState(null);
    const [openDetailShiftRequestAR, setOpenDetailShiftRequestAR] = useState(false);
    const [selectedDetailRequestAR, setSelectedDetailRequestAR] = useState(null);
    const [openDetailShiftRequestPartner, setOpenDetailShiftRequestPartner] = useState(false);
    const [selectedDetailRequestPartner, setSelectedDetailRequestPartner] = useState(null);
    const [openConfirmDelete, setOpenConfirmDelete] = useState(false);
    const [deleteInfo, setDeleteInfo] = useState(null); // lưu row cần xóa
    const [editUserOptions, setEditUserOptions] = useState([]);

    // Hàm mở dialog confirm khi click nút Delete
    const handleOpenConfirmDelete = (row) => {
        setDeleteInfo(row); // lưu toàn bộ row (cần info.id)
        setOpenConfirmDelete(true);
    };

    // Hàm đóng dialog confirm
    const handleCloseConfirmDelete = () => {
        setOpenConfirmDelete(false);
        setDeleteInfo(null);
    };

    const handleOpenDetailAR = (row) => {
        setSelectedDetailRequestAR(row);
        setOpenDetailShiftRequestAR(true);
    };

    const handleCloseDetailAR = () => {
        setOpenDetailShiftRequestAR(false);
        setSelectedDetailRequestAR(null);
        openedFromUrlRef.current = null;

        setSearchParams(prev => {
            const newParams = new URLSearchParams(prev);
            newParams.delete("requestShiftId");
            newParams.delete("requestId");
            return newParams;
        });
    };

    const handleOpenEdit = async (row) => {
        try {
            show();

            const payload = {
                requestId: row.id,
                langId: localStorage.getItem("i18nextLngId"),
            };

            const res = await requestSwapById(payload);
            const raw = res?.data?.data || res?.data?.request || res?.data;
            const data = Array.isArray(raw) ? raw[0] : raw;

            if (!data) {
                toast.error(t("common.cannot-find-request"));
                return;
            }

            // ✅ CALL API USER Ở ĐÂY
            let users = [];
            if (data.toGroupId) {
                const resUser = await getListUserGroup({
                    group: data.toGroupId, pageNo: 1,
                    recordPerPage: 10000,
                    langId: localStorage.getItem("i18nextLngId")
                });
                users = resUser.data?.data || [];
            }

            setEditUserOptions(users);

            const mergedData = {
                ...data,
                rosterId: row.rosterId,
            };

            setSelectedRequest(mergedData);
            setOpenEditShiftRequest(true);

        } catch (error) {
            if (error.response?.status !== 401) {
                toast.error(t(error?.response?.data.message) || t('common.network-timeout'));
            }
        } finally {
            hide();
        }
    };

    const handleCloseEdit = () => {
        setOpenEditShiftRequest(false);
        setSelectedRequest(null);
    };

    const handleOpenDetail = (row) => {
        setSelectedDetailRequest(row);
        setOpenDetailShiftRequest(true);
    };

    const handleCloseDetail = () => {
        setOpenDetailShiftRequest(false);
        setSelectedDetailRequest(null);
        openedFromUrlRef.current = null;

        setSearchParams(prev => {
            const newParams = new URLSearchParams(prev);
            newParams.delete("requestShiftId");
            newParams.delete("requestId");
            return newParams;
        });
    };

    const handleOpenDetailPartner = (row) => {
        setSelectedDetailRequestPartner(row);
        setOpenDetailShiftRequestPartner(true);
    };

    const handleCloseDetailPartner = () => {
        setOpenDetailShiftRequestPartner(false);
        setSelectedDetailRequestPartner(null);
        openedFromUrlRef.current = null;

        setSearchParams(prev => {
            const newParams = new URLSearchParams(prev);
            newParams.delete("requestShiftId");
            newParams.delete("requestId");
            return newParams;
        });
    };

    /* ================= Pagination ================= */
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(50);
    const [gridLoading, setGridLoading] = useState(false);
    const [rowData, setRowData] = useState([]);
    const [filteredRowData, setFilteredRowData] = useState([]);
    const [filteredRowCount, setFilteredRowCount] = useState(0);
    const [rowCount, setRowCount] = useState(0)
    const [requestInfo, setRequestInfo] = useState(null);
    const [show, hide] = useLoading();
    const [requestHistory, setRequestHistory] = useState([]);

    const getFromToByDateWithTZ = (date, timeZone) => {
        const base = dayjs(date).utcOffset(timeZone);

        return {
            from: base.startOf("day").utc().toISOString(),
            to: base.endOf("day").utc().toISOString(),
        };
    };

    useEffect(() => {
        const fetchData = async () => {
            const browserTZ = dayjs.tz.guess();

            const { from, to } = getFromToByDateWithTZ(
                selectedDate,
                genaralSettingTimeZone || "+00:00"
            );


            const payload = {
                page: page + 1,
                record: pageSize,
                from,
                to,
                userId: isAdmin ? selectedUser?.id : profile.userId,
                langId: localStorage.getItem("i18nextLngId"),
                groupId: selectedGroup,
                shiftId: selectedShift > 0 ? selectedShift : null,
                requestStatusId: selectedStatus > 0 ? selectedStatus : null,
            }
            try {
                setGridLoading(true);
                const response = await getRequestSwapList(payload)
                const requestsList = response.data.data || [];

                setRowData(requestsList);
                setRowCount(response.data.pagination.totalElements)
                setFilteredRowData(requestsList);
                setFilteredRowCount(requestsList.length);
            } catch (error) {
                if (error?.response?.data) {
                    if (error?.response?.data?.responseCode !== 401) {
                        toast.error(error.response.data.message);
                    }
                } else {
                    toast.error(t('common.network-timeout'));
                }
            } finally {
                setGridLoading(false);
            }
        };

        fetchData();
    }, [
        selectedDate,
        selectedUser?.id,
        selectedShift,
        selectedGroup,
        selectedStatus,
        page,
        pageSize,
        profile,
        isAdmin,
        t,
        refreshData,
    ]);

    // useEffect(() => {
    //     if (requestShiftId) {
    //         fetchRequestDetail(requestShiftId);
    //         fetchRequestHistory(requestShiftId);
    //     }
    // }, [requestShiftId]);

    useEffect(() => {
        if (!requestShiftId) return;
        // Tránh gọi mở detail trùng khi searchParams object đổi reference
        if (openedFromUrlRef.current === requestShiftId) return;
        openedFromUrlRef.current = requestShiftId;

        fetchRequestDetail(requestShiftId);
        fetchRequestHistory(requestIdParam || requestShiftId);
    }, [requestShiftId, requestIdParam]);

    const getFullNameByEmail = (email) => {
        if (!email) return "-";

        const normalizedEmail = String(email).trim().toLowerCase();

        const user = allUser.find(
            (u) =>
                u.email &&
                u.email.trim().toLowerCase() === normalizedEmail
        );

        // nếu tìm được thì trả fullName, không thì fallback về email
        return user?.fullName || email;
    };

    /* ================= Columns ================= */
    const columns = useMemo(
        () => [
            {
                field: "fullNameFrom",
                headerName: t("common.requester"),
                flex: 1,
                renderCell: (params) => {
                    const { row } = params;

                    const fromGroup = GroupData?.find(
                        g => g.id === row.fromGroupId
                    );

                    return row.fullNameFrom || fromGroup?.groupName || "-";
                }
            },
            {
                field: "date",
                headerName: t("common.date"),
                flex: 1.2,
                renderCell: ({ row }) => {

                    const fromDate = row.fromDate;
                    const toDate = row.toDate;

                    if (!fromDate) return "-";

                    const formattedFromDate = format(
                        parseISO(fromDate),
                        genaralSettingDateFormat
                    );

                    const formattedToDate = toDate
                        ? format(parseISO(toDate), genaralSettingDateFormat)
                        : null;

                    if (!formattedToDate || formattedFromDate === formattedToDate) {
                        return <span>{formattedFromDate}</span>;
                    }

                    return (
                        <span>
                            {formattedFromDate} → {formattedToDate}
                        </span>
                    );
                },
            },
            {
                field: "shift",
                headerName: t("common.shift"),
                flex: 1.2,
                renderCell: ({ row }) => {

                    const shiftNameFrom = row.shiftNameFrom;
                    const shiftNameTo = row.shiftNameTo;

                    return (
                        <span>
                            {shiftNameFrom} → {shiftNameTo}
                        </span>
                    );
                },
            },
            {
                field: "fullNameTo",
                headerName: t("common.swap-with"),
                flex: 1,
                renderCell: (params) => {
                    const { row } = params;

                    const toGroup = GroupData?.find(
                        g => g.id === row.toGroupId
                    );

                    return row.fullNameTo || toGroup?.groupName || "-";
                }
            },
            {
                field: "requestStatusName",
                headerName: t("common.status"),
                renderCell: (params) => {
                    const status = params.value;

                    const statusConfig = {
                        APPROVED: {
                            color: "text-green-600",
                            label: t("common.approved"),
                        },
                        REJECTED: {
                            color: "text-red-600",
                            label: t("common.rejected"),
                        },
                        PENDING: {
                            color: "text-orange-500",
                            label: t("common.pendding-request"),
                        },
                        PARTNER_PENDING: {
                            color: "text-orange-500",
                            label: t("common.pendding-partner-request"),
                        },
                        PARTNER_REJECTED: {
                            color: "text-red-600",
                            label: t("common.partner-rejected"),
                        },
                    };

                    const config = statusConfig[status] || {};

                    return (
                        <span className={`font-medium ${config.color || ""}`}>
                            {config.label || status}
                        </span>
                    );
                },
            },
            {
                field: "modifiedBy",
                headerName: t("common.approve-reject-by"),
                flex: 1.2,
                valueGetter: (value, row) => {
                    const { approvalStatusId, modifiedBy } = row || {};

                    if (approvalStatusId === 3) {
                        return t("common.not-processed-yet");
                    }

                    if (!modifiedBy) return "-";

                    return getFullNameByEmail(modifiedBy) || modifiedBy;
                },
                renderCell: (params) => {
                    const { approvalStatusId, modifiedBy } = params.row;

                    let label = "-";

                    if (approvalStatusId === 3) {
                        label = t("common.not-processed-yet"); // "chưa được xử lý"
                    } else {
                        label = getFullNameByEmail(modifiedBy);
                    }

                    return (
                        <Tooltip title={label} arrow>
                            <span className="truncate">{label}</span>
                        </Tooltip>
                    );
                },
            },
            {
                field: "actions",
                headerName: "",
                sortable: false,
                filterable: false,
                align: "center",
                renderCell: (params) => {

                    const row = params.row;

                    const isOwner = profile?.userId === row.fromUserId;
                    const isPartner = profile?.userId === row.toUserId;
                    const status = row.requestStatusName;

                    const isPending = status === "PENDING";
                    const isPartnerPending = status === "PARTNER_PENDING";

                    const isAR =
                        status === "APPROVED" ||
                        status === "REJECTED" ||
                        status === "PARTNER_REJECTED";

                    const handleDetail = () => {
                        fetchRequestDetail(row.id);
                        fetchRequestHistory(row.requestId);
                    };

                    const iconBtnClass =
                        "inline-flex items-center justify-center w-8 h-8 shrink-0 rounded-lg hover:bg-gray-100 transition cursor-pointer p-0";

                    return (
                        <div
                            className="flex flex-nowrap items-center justify-start gap-1 h-full w-full"
                            onClick={(e) => e.stopPropagation()}
                        >
                            {/* PARTNER xử lý */}
                            {isPartner && isPartnerPending && (
                                <Tooltip title={t("button.detail")} arrow>
                                    <button
                                        type="button"
                                        className={iconBtnClass}
                                        onClick={handleDetail}
                                    >
                                        <InfoOutlinedIcon sx={{ fontSize: 20 }} className="text-[#0057FF]" />
                                    </button>
                                </Tooltip>
                            )}

                            {/* ADMIN xử lý */}
                            {isAdmin && isPending && (
                                <Tooltip title={t("button.detail")} arrow>
                                    <button
                                        type="button"
                                        className={iconBtnClass}
                                        onClick={handleDetail}
                                    >
                                        <InfoOutlinedIcon sx={{ fontSize: 20 }} className="text-[#0057FF]" />
                                    </button>
                                </Tooltip>
                            )}

                            {/* OWNER */}
                            {isOwner && (isPending || isPartnerPending) && (
                                <>
                                    {isOwner && isPartnerPending && (
                                        <Tooltip title={t("button.edit")} arrow>
                                            <button
                                                type="button"
                                                className={iconBtnClass}
                                                onClick={() => handleOpenEdit(params.row)}
                                            >
                                                <EditNew20pxSvg width={20} height={20} />
                                            </button>
                                        </Tooltip>
                                    )}

                                    <Tooltip title={t("button.delete")} arrow>
                                        <button
                                            type="button"
                                            className={`${iconBtnClass} hover:bg-red-100`}
                                            onClick={() => handleOpenConfirmDelete(row)}
                                        >
                                            <DeleteIcon16pxSvg width={20} height={20} color="#D00D00" />
                                        </button>
                                    </Tooltip>
                                </>
                            )}

                            {/* APPROVED / REJECTED / PARTNER_REJECTED */}
                            {isAR && (
                                <Tooltip title={t("button.detail")} arrow>
                                    <button
                                        type="button"
                                        className={iconBtnClass}
                                        onClick={handleDetail}
                                    >
                                        <InfoOutlinedIcon sx={{ fontSize: 20 }} className="text-[#0057FF]" />
                                    </button>
                                </Tooltip>
                            )}
                        </div>
                    );
                }
            }
        ],
        [t, profile, isAdmin]
    );

    /* ================= RowsPerPage Change ================= */
    const handleRowsPerPageChange = (newPageSize) => {
        const size =
            typeof newPageSize === "number"
                ? newPageSize
                : parseInt(newPageSize.target.value, 10);

        setPage(0);
        setPageSize(size);
    };

    const fetchRequestDetail = async (id) => {
        try {
            show();
            setRequestInfo(null);

            const payload = {
                requestId: Number(id),
                langId: localStorage.getItem("i18nextLngId"),
            };

            const res = await requestSwapById(payload);
            const raw = res?.data?.data || res?.data?.request || res?.data;
            const data = Array.isArray(raw) ? raw[0] : raw;

            if (!data) {
                toast.error(t("common.cannot-find-request"));
                return;
            }

            setRequestInfo(data);

            const status = data.requestStatusName;
            if (status === "PENDING") {
                setSelectedDetailRequest(data);
                setOpenDetailShiftRequest(true);
            } else if (status === "PARTNER_PENDING") {
                setSelectedDetailRequestPartner(data);
                setOpenDetailShiftRequestPartner(true);
            } else {
                setSelectedDetailRequestAR(data);
                setOpenDetailShiftRequestAR(true);
            }
        } catch (error) {
            toast.error(t("common.cannot-find-request"));
        } finally {
            hide();
        }
    };

    const fetchRequestHistory = async (id) => {
        const payload = {
            requestId: id,
            langId: localStorage.getItem("i18nextLngId"),
        };
        try {
            const response = await getHistoryRequest(payload);
            setRequestHistory(response.data.data);
        } catch (error) {
            console.log(error);
        }
    };

    const handleDeleteSwapRequest = async (requestId) => {
        const payload = {
            requestId: requestId,
            langId: localStorage.getItem("i18nextLngId")
        };

        try {
            show();

            const response = await deleteRequest(payload);

            if (
                response.data.message === 'Successful' ||
                response.data.message === 'Thành công'
            ) {
                toast.success(t('common.remove-successfully'));
                handleRefreshData(); // refresh grid
            } else {
                toast.error(response.data.message || t('common.delete-failed'));
            }
        } catch (error) {
            if (isAxiosError(error)) {
                if (error.response?.status !== 401) {
                    toast.error(
                        t(error.response?.data?.message || 'Có lỗi khi xóa yêu cầu')
                    );
                }
            } else {
                toast.error(t('common.network-timeout'));
            }
        } finally {
            hide();
        }
    };


    const usersDataNoGroup = useMemo(() => {
        if (!usersData) return [];

        const map = new Map();

        usersData.forEach(item => {
            if (item.userId && !map.has(item.userId)) {
                map.set(item.userId, item);
            }
        });

        return Array.from(map.values());
    }, [usersData]);

    const groupsDataOnly = useMemo(() => {
        if (!usersData) return [];

        const map = new Map();

        usersData.forEach(item => {
            if (item.groupId && !map.has(item.groupId)) {
                map.set(item.groupId, item);
            }
        });

        return Array.from(map.values());
    }, [usersData]);

    const hasRows = filteredRowData.length > 0;
    const gridHeight = hasRows ? 480 : 360;
    

    /* ================= Render ================= */
    return (
        <>
            <div className="w-full min-w-0 max-w-full overflow-hidden">
                <div
                    className={`w-full max-w-full ${hasRows ? "overflow-x-auto" : "overflow-x-hidden"}`}
                >
                <div
                    className="bg-white rounded-[10px]"
                    style={{
                        boxShadow: "0px 2px 10px 0px rgba(0,0,0,0.1)",
                    }}
                >
                <StyledDataGrid
                    rows={filteredRowData}
                    columns={columns}
                    rowCount={filteredRowCount}
                    paginationMode="client"
                    disableRowSelectionOnClick
                    loading={gridLoading}
                    getRowId={(row) => row.id}
                    sx={{
                        width: "100%",
                        maxWidth: "100%",
                        overflow: "hidden",
                        height: gridHeight,
                        "& .MuiDataGrid-scrollbar--vertical": {
                            display: "none !important",
                        },
                        "& .MuiDataGrid-scrollbar--horizontal": {
                            display: hasRows ? undefined : "none !important",
                        },

                        "& .MuiDataGrid-scrollbarFiller": {
                            display: "none !important",
                        },
                        "& .MuiDataGrid-root": {
                            width: "100%",
                            maxWidth: "100%",
                        },
                        "& .MuiDataGrid-main": {
                            width: "100%",
                            maxWidth: "100%",
                            overflow: "hidden",
                        },
                        "& .MuiDataGrid-columnHeaders": {
                            paddingRight: 0,
                        },
                        "& .MuiDataGrid-topContainer": {
                            paddingRight: 0,
                        },

                        "& .MuiDataGrid-virtualScroller": {
                            overflow: hasRows ? "auto !important" : "hidden !important",
                            scrollbarWidth: hasRows ? "thin" : "none",
                        },
                        "& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
                            width: hasRows ? 8 : 0,
                            height: hasRows ? 8 : 0,
                        },

                        "& input[type=number]::-webkit-inner-spin-button, \
                 & input[type=number]::-webkit-outer-spin-button": {
                            WebkitAppearance: "none",
                            margin: 0,
                        },

                        "& input[type=number]": {
                            textAlign: "center",
                            MozAppearance: "textfield",
                            WebkitAppearance: "none",
                            padding: "5px !important",
                            height: "100%",
                            pointerEvents: "none",
                            caretColor: "transparent",
                            userSelect: "none",
                            paddingTop: "8px !important",
                            paddingBottom: "8px !important"
                        },
                    }}
                    slots={{
                        pagination: CustomPagination,
                        noRowsOverlay: NoRowOverlay,
                    }}
                    slotProps={{
                        pagination: {
                            page,
                            count: filteredRowCount,
                            rowsPerPage: pageSize,
                            onPageChange: setPage,
                            onRowsPerPageChange: handleRowsPerPageChange,
                        },
                    }}
                />
                </div>
                </div>
            </div>

            {/* ================= Edit Dialog ================= */}
            {openEditShiftRequest && (
                <EditShiftRequestDialog
                    onClose={handleCloseEdit}
                    requestData={selectedRequest}
                    shiftsData={shiftsData}
                    userOptions={editUserOptions}
                    handleRefreshData={handleRefreshData}
                />
            )}

            {openDetailShiftRequest && (
                <DetailShiftRequestDialog
                    onClose={handleCloseDetail}
                    requestData={selectedDetailRequest}
                    shiftsData={shiftsData}
                    allUser={allUser}
                    requestHistory={requestHistory}
                    refreshData={refreshData}
                    handleRefreshData={handleRefreshData}
                    GroupData={GroupData}
                />
            )}

            {openDetailShiftRequestPartner && (
                <DetailShiftRequestDialogPartner
                    onClose={handleCloseDetailPartner}
                    requestData={selectedDetailRequestPartner}
                    shiftsData={shiftsData}
                    allUser={allUser}
                    requestHistory={requestHistory}
                    refreshData={refreshData}
                    handleRefreshData={handleRefreshData}
                    GroupData={GroupData}
                />
            )}

            {openDetailShiftRequestAR && (
                <DetailShiftRequestDialogAR
                    onClose={handleCloseDetailAR}
                    requestData={selectedDetailRequestAR}
                    shiftsData={shiftsData}
                    allUser={allUser}
                    requestHistory={requestHistory}
                    GroupData={GroupData}
                />
            )}

            {openConfirmDelete && deleteInfo && (
                <RemoveRequestDialog
                    userId={profile?.userId}
                    onClose={handleCloseConfirmDelete}
                    onRefresh={() => {
                        handleRefreshData();
                        handleCloseConfirmDelete();
                    }}
                    refreshData={refreshData}
                    info={deleteInfo}
                    isSwap={true}
                />
            )}
        </>
    );
};

export default ShiftRequestGridTable;
